if (!customElements.get('learn-scrollbar')) {
  class LearnScrollbar extends HTMLElement {
    connectedCallback() {
      const selector = this.dataset.target;
      this.scroller = selector ? this.parentElement.querySelector(selector) : this.previousElementSibling;
      this.thumb = this.querySelector('.learn-scrollbar__thumb');
      if (!this.scroller || !this.thumb) return;

      this.frame = null;
      this.update = this.update.bind(this);
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };

      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.observer = new ResizeObserver(this.onScroll);
      this.observer.observe(this.scroller);

      this.thumb.addEventListener('pointerdown', (event) => this.startDrag(event));
      this.addEventListener('pointerdown', (event) => {
        if (event.target === this.thumb) return;
        this.jumpTo(event.clientX);
      });
      this.update();
    }

    disconnectedCallback() {
      if (!this.scroller) return;
      this.scroller.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.observer) this.observer.disconnect();
    }

    metrics() {
      const max = this.scroller.scrollWidth - this.scroller.clientWidth;
      const track = this.clientWidth;
      const ratio = this.scroller.scrollWidth ? this.scroller.clientWidth / this.scroller.scrollWidth : 1;
      const thumb = Math.max(48, track * Math.min(1, ratio));
      return { max, track, thumb, room: track - thumb };
    }

    update() {
      const { max, thumb, room } = this.metrics();
      this.hidden = max <= 1;
      if (this.hidden) return;
      const progress = this.scroller.scrollLeft / max;
      this.thumb.style.width = `${thumb}px`;
      this.thumb.style.transform = `translateX(${room * progress}px)`;
    }

    jumpTo(clientX) {
      const { max, thumb, room } = this.metrics();
      if (room <= 0) return;
      const left = clientX - this.getBoundingClientRect().left - thumb / 2;
      this.scroller.scrollTo({ left: (Math.min(Math.max(left, 0), room) / room) * max, behavior: 'smooth' });
    }

    startDrag(event) {
      event.preventDefault();
      const { max, room } = this.metrics();
      if (room <= 0) return;
      const startX = event.clientX;
      const startLeft = this.scroller.scrollLeft;
      const snap = this.scroller.style.scrollSnapType;
      this.scroller.style.scrollSnapType = 'none';
      this.classList.add('is-dragging');
      this.thumb.setPointerCapture(event.pointerId);

      const move = (e) => {
        this.scroller.scrollLeft = startLeft + ((e.clientX - startX) / room) * max;
      };
      const end = () => {
        this.scroller.style.scrollSnapType = snap;
        this.classList.remove('is-dragging');
        this.thumb.removeEventListener('pointermove', move);
        this.thumb.removeEventListener('pointerup', end);
        this.thumb.removeEventListener('pointercancel', end);
      };
      this.thumb.addEventListener('pointermove', move);
      this.thumb.addEventListener('pointerup', end);
      this.thumb.addEventListener('pointercancel', end);
    }
  }

  customElements.define('learn-scrollbar', LearnScrollbar);
}
